<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Campaign Discount</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Campaign Discount</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Campaign Discount</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.cDisc_campaign }}</v-subheader>
                <div class="queryValue" v-for="item in filter_cDisc_campaignList" :key="item.code">{{ item.code }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.cDisc_campaign"
                  :items="cDisc_campaignList"
                  v-model="form.cDisc_campaign"
                  item-text="code"
                  item-value="value"
                  data-vv-name="cDisc_campaign"
                  :data-vv-as="labels.cDisc_campaign"
                  :error-messages="errors.collect('cDisc_campaign')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.cDisc_effDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(cloneQueryEffDate) }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <cal-picker
                  :label="labels.cDisc_effDate"
                  v-model="form.cDisc_effDate"
                  :error-messages="errors.collect('cDisc_effDate')"
                  data-vv-name="cDisc_effDate"
                  :data-vv-as="labels.cDisc_effDate"
                  v-validate="effDateValidation"
                ></cal-picker>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <v-expansion-panels v-model="panel1" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-format-align-justify</v-icon> Discount / Loading 1</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs4 v-if="queryMode">
                              <v-subheader class="queryLabel">{{ labels.cDisc_discLdg1 }}</v-subheader>
                              <div class="queryValue" v-for="item in filter1_cDisc_discLdgList" :key="item.code">{{ item.discLdgDesc }}</div>
                            </v-flex>
                            <v-flex xs4 v-else>
                              <v-autocomplete
                                :label="labels.cDisc_discLdg1"
                                :items="cDisc_discLdgList"
                                v-model="form.cDisc_discLdg1"
                                item-text="discLdgDesc"
                                item-value="discLdg"
                                data-vv-name="cDisc_discLdg1"
                                :data-vv-as="labels.cDisc_discLdg1"
                                :error-messages="errors.collect('cDisc_discLdg1')"
                                v-validate="''"
                              ></v-autocomplete>
                            </v-flex>

                            <v-flex xs4 v-if="queryMode">
                              <v-subheader class="queryLabel">{{ labels.cDisc_discLdg1Pct }}</v-subheader>
                              <div class="queryValue">{{ form.cDisc_discLdg1Pct }}</div>
                            </v-flex>
                            <v-flex xs4 v-else>
                              <v-text-field
                                v-model="form.cDisc_discLdg1Pct"
                                :label="labels.cDisc_discLdg1Pct"
                                :error-messages="errors.collect('cDisc_discLdg1Pct')"
                                data-vv-name="cDisc_discLdg1Pct"
                                :data-vv-as="labels.cDisc_discLdg1Pct"
                                v-validate="'mask_decimal:3|mask_max_value:999999999999999.999'"
                              ></v-text-field>
                            </v-flex>

                            <v-flex xs4 v-if="queryMode">
                              <v-checkbox readonly v-model="form.cDisc_protectDiscLdg1" :label="labels.cDisc_protectDiscLdg1"></v-checkbox>
                            </v-flex>
                            <v-flex xs4 v-else>
                              <v-checkbox
                                v-model="form.cDisc_protectDiscLdg1"
                                :label="labels.cDisc_protectDiscLdg1"
                                :error-messages="errors.collect('cDisc_protectDiscLdg1')"
                                data-vv-name="cDisc_protectDiscLdg1"
                                :data-vv-as="labels.cDisc_protectDiscLdg1"
                                v-validate="'required'"
                              ></v-checkbox>
                            </v-flex>
                          </v-layout>

                          <v-layout row wrap>
                            <v-flex xs4 v-if="queryMode">
                              <v-subheader class="queryLabel">{{ labels.cDisc_applyDiscLdg1 }}</v-subheader>
                              <div class="queryValue" v-for="item in filter1_cDisc_applyDiscLdg" :key="item.code">{{ item.discLdgDesc }}</div>
                            </v-flex>
                            <v-flex xs4 v-else>
                              <v-autocomplete
                                :label="labels.cDisc_applyDiscLdg1"
                                :items="cDisc_applyDiscLdgList"
                                v-model="form.cDisc_applyDiscLdg1"
                                item-text="value"
                                item-value="code"
                                data-vv-name="cDisc_applyDiscLdg1"
                                :data-vv-as="labels.cDisc_applyDiscLdg1"
                                :error-messages="errors.collect('cDisc_applyDiscLdg1')"
                                v-validate="'required|max:1'"
                              ></v-autocomplete>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-flex>
            <hr />
            <v-flex xs12>
              <v-expansion-panels v-model="panel2" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-format-align-justify</v-icon> Discount / Loading 2</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs4 v-if="queryMode">
                              <v-subheader class="queryLabel">{{ labels.cDisc_discLdg2 }}</v-subheader>
                              <div class="queryValue" v-for="item in filter2_cDisc_discLdgList" :key="item.code">{{ item.discLdgDesc }}</div>
                            </v-flex>
                            <v-flex xs4 v-else>
                              <v-autocomplete
                                :label="labels.cDisc_discLdg2"
                                :items="cDisc_discLdgList"
                                v-model="form.cDisc_discLdg2"
                                item-text="discLdgDesc"
                                item-value="discLdg"
                                data-vv-name="cDisc_discLdg2"
                                :data-vv-as="labels.cDisc_discLdg2"
                                :error-messages="errors.collect('cDisc_discLdg2')"
                                v-validate="''"
                              ></v-autocomplete>
                            </v-flex>

                            <v-flex xs4 v-if="queryMode">
                              <v-subheader class="queryLabel">{{ labels.cDisc_discLdg2Pct }}</v-subheader>
                              <div class="queryValue">{{ form.cDisc_discLdg2Pct }}</div>
                            </v-flex>
                            <v-flex xs4 v-else>
                              <v-text-field
                                v-model="form.cDisc_discLdg2Pct"
                                :label="labels.cDisc_discLdg2Pct"
                                :error-messages="errors.collect('cDisc_discLdg2Pct')"
                                data-vv-name="cDisc_discLdg2Pct"
                                :data-vv-as="labels.cDisc_discLdg2Pct"
                                v-validate="'mask_decimal:3|mask_max_value:999999999999999.999'"
                              ></v-text-field>
                            </v-flex>

                            <v-flex xs4 v-if="queryMode">
                              <v-checkbox readonly v-model="form.cDisc_protectDiscLdg2" :label="labels.cDisc_protectDiscLdg2"></v-checkbox>
                            </v-flex>
                            <v-flex xs4 v-else>
                              <v-checkbox
                                v-model="form.cDisc_protectDiscLdg2"
                                :label="labels.cDisc_protectDiscLdg2"
                                :error-messages="errors.collect('cDisc_protectDiscLdg2')"
                                data-vv-name="cDisc_protectDiscLdg2"
                                :data-vv-as="labels.cDisc_protectDiscLdg2"
                                v-validate="'required'"
                              ></v-checkbox>
                            </v-flex>
                          </v-layout>

                          <v-layout row wrap>
                            <v-flex xs4 v-if="queryMode">
                              <v-subheader class="queryLabel">{{ labels.cDisc_applyDiscLdg2 }}</v-subheader>
                              <div class="queryValue" v-for="item in filter2_cDisc_applyDiscLdg" :key="item.code">{{ item.value }}</div>
                            </v-flex>
                            <v-flex xs4 v-else>
                              <v-autocomplete
                                :label="labels.cDisc_applyDiscLdg2"
                                :items="cDisc_applyDiscLdgList"
                                v-model="form.cDisc_applyDiscLdg2"
                                item-text="value"
                                item-value="code"
                                data-vv-name="cDisc_applyDiscLdg2"
                                :data-vv-as="labels.cDisc_applyDiscLdg2"
                                :error-messages="errors.collect('cDisc_applyDiscLdg2')"
                                v-validate="'required|max:1'"
                              ></v-autocomplete>
                            </v-flex>

                            <v-flex xs4 v-if="queryMode">
                              <v-subheader class="queryLabel">{{ labels.cDisc_discLdg2GN }}</v-subheader>
                              <div class="queryValue" v-for="item in filter2_cDisc_discLdgGN" :key="item.code">{{ item.value }}</div>
                            </v-flex>
                            <v-flex xs4 v-else>
                              <v-autocomplete
                                :label="labels.cDisc_discLdg2GN"
                                :items="cDisc_discLdgGNList"
                                v-model="form.cDisc_discLdg2GN"
                                item-text="value"
                                item-value="code"
                                data-vv-name="cDisc_discLdg2GN"
                                :data-vv-as="labels.cDisc_discLdg2GN"
                                :error-messages="errors.collect('cDisc_discLdg2GN')"
                                v-validate="'required'"
                              ></v-autocomplete>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-flex>
            <hr />
            <v-flex xs12>
              <v-expansion-panels v-model="panel3" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-format-align-justify</v-icon> Discount / Loading 3</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs4 v-if="queryMode">
                              <v-subheader class="queryLabel">{{ labels.cDisc_discLdg3 }}</v-subheader>
                              <div class="queryValue" v-for="item in filter3_cDisc_discLdgList" :key="item.code">{{ item.discLdg }}</div>
                            </v-flex>
                            <v-flex xs4 v-else>
                              <v-autocomplete
                                :label="labels.cDisc_discLdg3"
                                :items="cDisc_discLdgList"
                                v-model="form.cDisc_discLdg3"
                                item-text="discLdgDesc"
                                item-value="discLdg"
                                data-vv-name="cDisc_discLdg3"
                                :data-vv-as="labels.cDisc_discLdg3"
                                :error-messages="errors.collect('cDisc_discLdg3')"
                                v-validate="''"
                              ></v-autocomplete>
                            </v-flex>

                            <v-flex xs4 v-if="queryMode">
                              <v-subheader class="queryLabel">{{ labels.cDisc_discLdg3Pct }}</v-subheader>
                              <div class="queryValue">{{ form.cDisc_discLdg3Pct }}</div>
                            </v-flex>
                            <v-flex xs4 v-else>
                              <v-text-field
                                v-model="form.cDisc_discLdg3Pct"
                                :label="labels.cDisc_discLdg3Pct"
                                :error-messages="errors.collect('cDisc_discLdg3Pct')"
                                data-vv-name="cDisc_discLdg3Pct"
                                :data-vv-as="labels.cDisc_discLdg3Pct"
                                v-validate="'mask_decimal:3|mask_max_value:999999999999999.999'"
                              ></v-text-field>
                            </v-flex>

                            <v-flex xs4 v-if="queryMode">
                              <v-checkbox readonly v-model="form.cDisc_protectDiscLdg3" :label="labels.cDisc_protectDiscLdg3"></v-checkbox>
                            </v-flex>
                            <v-flex xs4 v-else>
                              <v-checkbox
                                v-model="form.cDisc_protectDiscLdg3"
                                :label="labels.cDisc_protectDiscLdg3"
                                :error-messages="errors.collect('cDisc_protectDiscLdg3')"
                                data-vv-name="cDisc_protectDiscLdg3"
                                :data-vv-as="labels.cDisc_protectDiscLdg3"
                                v-validate="'required'"
                              ></v-checkbox>
                            </v-flex>
                          </v-layout>

                          <v-layout row wrap>
                            <v-flex xs4 v-if="queryMode">
                              <v-subheader class="queryLabel">{{ labels.cDisc_applyDiscLdg3 }}</v-subheader>
                              <div class="queryValue" v-for="item in filter3_cDisc_applyDiscLdg" :key="item.code">{{ item.value }}</div>
                            </v-flex>
                            <v-flex xs4 v-else>
                              <v-autocomplete
                                :label="labels.cDisc_applyDiscLdg3"
                                :items="cDisc_applyDiscLdgList"
                                v-model="form.cDisc_applyDiscLdg3"
                                item-text="value"
                                item-value="code"
                                data-vv-name="cDisc_applyDiscLdg3"
                                :data-vv-as="labels.cDisc_applyDiscLdg3"
                                :error-messages="errors.collect('cDisc_applyDiscLdg3')"
                                v-validate="'required|max:1'"
                              ></v-autocomplete>
                            </v-flex>

                            <v-flex xs4 v-if="queryMode">
                              <v-subheader class="queryLabel">{{ labels.cDisc_discLdg3GN }}</v-subheader>
                              <div class="queryValue" v-for="item in filter3_cDisc_discLdgGN" :key="item.code">{{ item.value }}</div>
                            </v-flex>
                            <v-flex xs4 v-else>
                              <v-autocomplete
                                :label="labels.cDisc_discLdg3GN"
                                :items="cDisc_discLdgGNList"
                                v-model="form.cDisc_discLdg3GN"
                                item-text="value"
                                item-value="code"
                                data-vv-name="cDisc_discLdg3GN"
                                :data-vv-as="labels.cDisc_discLdg3GN"
                                :error-messages="errors.collect('cDisc_discLdg3GN')"
                                v-validate="'required'"
                              ></v-autocomplete>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-flex>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-layout style="margin: auto -8px">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-spacer class="mt-1"></v-spacer>
          <v-container fluid grid-list-lg>
            <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
              <span>Cancel</span>
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
            <v-btn :disabled="queryMode" color="primary" dark class="mr-2" @click="doSave" :loading="submitting">
              {{ newMode ? 'Save' : '' }}{{ reviewMode ? 'Update' : '' }}
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate, removeTime } from '@/utils/date'
import clone from 'clone'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      labels: {
        cDisc_campaign: 'Campaign',
        cDisc_effDate: 'Effective Date',
        cDisc_discLdg1: 'Discount / Loading Code',
        cDisc_discLdg1Pct: '%',
        cDisc_protectDiscLdg1: 'Protect',
        cDisc_applyDiscLdg1: 'Applicable for',
        cDisc_discLdg2: 'Discount / Loading Code',
        cDisc_discLdg2Pct: '%',
        cDisc_protectDiscLdg2: 'Protect',
        cDisc_applyDiscLdg2: 'Applicable for',
        cDisc_discLdg2GN: 'Apply on',
        cDisc_discLdg3: 'Discount / Loading Code',
        cDisc_discLdg3Pct: '%',
        cDisc_protectDiscLdg3: 'Protect',
        cDisc_applyDiscLdg3: 'Applicable for',
        cDisc_discLdg3GN: 'Apply on',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        actionKey: 'CAMPAIGN_DISCOUNT',
        cDisc_campaign: '',
        cDisc_effDate: new Date(),
        cDisc_discLdg1: '',
        cDisc_discLdg1Pct: 0,
        cDisc_protectDiscLdg1: false,
        cDisc_applyDiscLdg1: 'B',
        cDisc_discLdg2: '',
        cDisc_discLdg2Pct: 0,
        cDisc_protectDiscLdg2: false,
        cDisc_applyDiscLdg2: 'B',
        cDisc_discLdg2GN: true,
        cDisc_discLdg3: '',
        cDisc_discLdg3Pct: 0,
        cDisc_protectDiscLdg3: false,
        cDisc_applyDiscLdg3: 'B',
        cDisc_discLdg3GN: true
      },
      cloneQueryEffDate: '',
      newMode: false,
      queryMode: false,
      reviewMode: false,
      submitting: false,
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined,
      cDisc_campaignList: [],
      cDisc_discLdgList: [],
      cDisc_applyDiscLdgList: [
        { code: 'A', value: 'Annual' },
        { code: 'M', value: 'Monthly' },
        { code: 'B', value: 'Both' }
      ],
      cDisc_discLdgGNList: [
        { code: true, value: 'Gross' },
        { code: false, value: 'Net' }
      ],
      panel1: [],
      panel2: [0],
      panel3: [0]
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetchCampaign() {
      const apiURI = this.menu.getRelatedData
      if (apiURI) {
        this.loading = true
        try {
          const relatedTask = { actionKey: 'RELATED_CAMPAIGN' }
          const result = await this.$http.get(expandURI(apiURI, relatedTask))
          const { data } = result.data
          this.cDisc_campaignList = []
          if (data) {
            data.map((campList) => {
              const convertList = {
                code: campList.campaign + ' - ' + campList.description,
                value: campList.campaign
              }
              this.cDisc_campaignList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doFetchDiscLdg() {
      const apiURI = this.menu.getRelatedData
      if (apiURI) {
        this.loading = true
        try {
          const relatedTask = { actionKey: 'RELATED_DISCOUNT_LOADING' }
          const result = await this.$http.get(expandURI(apiURI, relatedTask))
          const { data } = result.data
          this.cDisc_discLdgList = []
          if (data) {
            data.map((discLdgList) => {
              const convertList = {
                discLdg: discLdgList.discLdg,
                discLdgDesc: discLdgList.discLdg + ' - ' + discLdgList.discLdgDesc,
                discLdgPct: discLdgList.discLdgPct
              }
              this.cDisc_discLdgList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doFetch() {
      const apiURI = this.menu.getDetail
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.put(apiURI, this.objParam)
          const { data } = result.data
          if (data) {
            this.form.actionKey = data.campaignDiscDto.actionKey
            this.form.cDisc_campaign = data.campaignDiscDto.cDisc_campaign
            this.form.cDisc_effDate = data.campaignDiscDto.cDisc_effDate
            this.form.cDisc_discLdg1 = data.campaignDiscDto.cDisc_discLdg1
            this.form.cDisc_discLdg1Pct = data.campaignDiscDto.cDisc_discLdg1Pct
            this.form.cDisc_protectDiscLdg1 = data.campaignDiscDto.cDisc_protectDiscLdg1
            this.form.cDisc_applyDiscLdg1 = data.campaignDiscDto.cDisc_applyDiscLdg1
            this.form.cDisc_discLdg2 = data.campaignDiscDto.cDisc_discLdg2
            this.form.cDisc_discLdg2Pct = data.campaignDiscDto.cDisc_discLdg2Pct
            this.form.cDisc_protectDiscLdg2 = data.campaignDiscDto.cDisc_protectDiscLdg2
            this.form.cDisc_applyDiscLdg2 = data.campaignDiscDto.cDisc_applyDiscLdg2
            this.form.cDisc_discLdg2GN = data.campaignDiscDto.cDisc_discLdg2GN
            this.form.cDisc_discLdg3 = data.campaignDiscDto.cDisc_discLdg3
            this.form.cDisc_discLdg3Pct = data.campaignDiscDto.cDisc_discLdg3Pct
            this.form.cDisc_protectDiscLdg3 = data.campaignDiscDto.cDisc_protectDiscLdg3
            this.form.cDisc_applyDiscLdg3 = data.campaignDiscDto.cDisc_applyDiscLdg3
            this.form.cDisc_discLdg3GN = data.campaignDiscDto.cDisc_discLdg3GN
            this.createdBy = data.createdBy
            this.createdDate = data.createdDate
            this.modifiedBy = data.modifiedBy
            this.modifiedDate = data.modifiedDate
          }
          this.cloneQueryEffDate = clone(this.form.cDisc_effDate)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'campaignDiscList' })
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
            // } else {
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.doCreate
      if (apiURI) {
        this.submitting = true
        try {
          this.form.cDisc_effDate = removeTime(this.form.cDisc_effDate)
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.doUpdate
      if (apiURI) {
        this.submitting = true
        try {
          this.form.cDisc_effDate = removeTime(this.form.cDisc_effDate)
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  watch: {
    'form.cDisc_discLdg1'(newVal, oldVal) {
      if (newVal) {
        this.form.cDisc_discLdg1Pct = this.filter1_cDisc_discLdgList[0].discLdgPct
      }
    },
    'form.cDisc_discLdg2'(newVal, oldVal) {
      if (newVal) {
        this.form.cDisc_discLdg2Pct = this.filter2_cDisc_discLdgList[0].discLdgPct
      }
    },
    'form.cDisc_discLdg3'(newVal, oldVal) {
      if (newVal) {
        this.form.cDisc_discLdg3Pct = this.filter3_cDisc_discLdgList[0].discLdgPct
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.campaignParam.menu
    },
    modeParam() {
      return this.$route.params.paramMode
    },
    objParam() {
      return this.$route.params.paramObjRes
    },
    effDateValidation() {
      return 'required'
    },
    filter_cDisc_campaignList() {
      return this.cDisc_campaignList.filter((list) => {
        return list.value === this.form.cDisc_campaign
      })
    },
    filter1_cDisc_discLdgList() {
      return this.cDisc_discLdgList.filter((list) => {
        return list.discLdg === this.form.cDisc_discLdg1
      })
    },
    filter2_cDisc_discLdgList() {
      return this.cDisc_discLdgList.filter((list) => {
        return list.discLdg === this.form.cDisc_discLdg2
      })
    },
    filter3_cDisc_discLdgList() {
      return this.cDisc_discLdgList.filter((list) => {
        return list.discLdg === this.form.cDisc_discLdg3
      })
    },
    filter1_cDisc_applyDiscLdg() {
      return this.cDisc_applyDiscLdgList.filter((list) => {
        return list.code === this.form.cDisc_applyDiscLdg1
      })
    },
    filter2_cDisc_applyDiscLdg() {
      return this.cDisc_applyDiscLdgList.filter((list) => {
        return list.code === this.form.cDisc_applyDiscLdg2
      })
    },
    filter3_cDisc_applyDiscLdg() {
      return this.cDisc_applyDiscLdgList.filter((list) => {
        return list.code === this.form.cDisc_applyDiscLdg3
      })
    },
    filter2_cDisc_discLdgGN() {
      return this.cDisc_discLdgGNList.filter((list) => {
        return list.code === this.form.cDisc_discLdg2GN
      })
    },
    filter3_cDisc_discLdgGN() {
      return this.cDisc_discLdgGNList.filter((list) => {
        return list.code === this.form.cDisc_discLdg3GN
      })
    }
  },
  created() {
    this.doFetchCampaign()
    this.doFetchDiscLdg()
    if (this.modeParam === 'create') {
      this.newMode = true
    } else if (!this.modeParam) {
      this.doCancel()
    } else {
      if (this.modeParam === 'query') {
        this.queryMode = true
      } else if (this.modeParam === 'review') {
        this.reviewMode = true
      }
      this.doFetch()
    }
  },
  mixins: [MessageMixin]
}
</script>
